import { render, staticRenderFns } from "./tezhengfenxiChats.vue?vue&type=template&id=b5aa29ce&scoped=true"
import script from "./tezhengfenxiChats.vue?vue&type=script&lang=js"
export * from "./tezhengfenxiChats.vue?vue&type=script&lang=js"
import style0 from "./tezhengfenxiChats.vue?vue&type=style&index=0&id=b5aa29ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aa29ce",
  null
  
)

export default component.exports